export default defineAppConfig({
  layer: {
    name: 'Nuxt UI layer'
  }
})

declare module '@nuxt/schema' {
  interface AppConfigInput {
    layer?: {
      /** Project name */
      name?: string
    }
  }
}
